import { render, staticRenderFns } from "./CreateTenantConfig.vue?vue&type=template&id=d0a6bcee"
import script from "./CreateTenantConfig.vue?vue&type=script&lang=js"
export * from "./CreateTenantConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports